import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VietnamMapComponent } from './vietnam-map.component';

@NgModule({
  imports: [CommonModule],
  declarations: [VietnamMapComponent],
  exports: [VietnamMapComponent]
})
export class VietnamMapModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/vietnam-map/vietnam-map.module.ts